(() => {
  'use strict';
  if(window.__CANFOTO_E1_F10_R14D_UNIFIED_PRODUCT_CARD__) return;
  window.__CANFOTO_E1_F10_R14D_UNIFIED_PRODUCT_CARD__ = true;

  // R14D-FIX6 remains the sealed Collection/PDP base. FINAL1-R2H is an explicit user-authorized
  // HOME presentation amendment: native HOME product-card internals adopt the sealed Collection card
  // hierarchy while the Shopify/F08 section, rail, order, limit and commerce truth remain untouched.
  const VERSION='CANFOTO-E1-F10-R14D-SEALED-CARD-PARITY-R1';
  const HOME_EXTENSION_VERSION='CANFOTO-E1-FINAL1-R2H-HOME-COLLECTION-CARD-PARITY-R1';
  const FIRST_MEDIA_VIDEO_VERSION='CANFOTO-E1-FINAL1-R2H-FIX2-FIRST-MEDIA-VIDEO-R1';
  const SHOP_LOOK_NATIVE_LOCK_VERSION='CANFOTO-E1-FINAL1-R2J-H6-SHOP-LOOK-NATIVE-EXCLUSION-R1';
  const HOME_DEFER_VERSION='CANFOTO-PERFORMANCE-P2-R1-HOME-PRODUCT-DEFER';
  const COLLECTION_SERVER_FIRST_VERSION='CANFOTO-PERFORMANCE-P0-COLLECTION-SERVER-FIRST-R2';
  const PDP_RELATED_SERVER_FIRST_VERSION='CANFOTO-PERFORMANCE-P0-C-PDP-RELATED-SERVER-FIRST-R1';
  const HOME_SERVER_FIRST_VERSION='CANFOTO-PERFORMANCE-P0-D-HOME-SERVER-FIRST-R1';
  const STANDARD_SURFACE_SERVER_ONLY_VERSION='CANFOTO-PERFORMANCE-P0-E-STANDARD-SURFACE-SERVER-ONLY-R1';
  const RECENT_KEY='canfoto_recently_viewed_v1';
  const MAX_RECENT=8;
  const MAX_THUMBS=6;
  const cache=new Map();
  const q=(s,r=document)=>r.querySelector(s);
  const qa=(s,r=document)=>[...r.querySelectorAll(s)];
  const clean=v=>String(v??'').replace(/\s+/g,' ').trim();
  const currentHandle=(location.pathname.match(/\/products\/([^/?#]+)/)||[])[1]||'';

  const state={
    version:VERSION,
    initialOrder:{home:[],collection:[],related:[],recent:[]},
    currentOrder:{home:[],collection:[],related:[],recent:[]},
    initialDomOrder:{home:[],collection:[],related:[]},
    currentDomOrder:{home:[],collection:[],related:[]},
    orderTokenSeq:{home:0,collection:0,related:0},
    homeExtension:HOME_EXTENSION_VERSION,
    firstMediaVideoExtension:FIRST_MEDIA_VIDEO_VERSION,
    shopLookNativeLock:SHOP_LOOK_NATIVE_LOCK_VERSION,
    collectionServerFirst:COLLECTION_SERVER_FIRST_VERSION,
    pdpRelatedServerFirst:PDP_RELATED_SERVER_FIRST_VERSION,
    homeServerFirst:HOME_SERVER_FIRST_VERSION,
    serverHydratedHandles:[],
    adaptedHandles:[],failed:[],
    mutationContract:{commerceOwner:'SHOPIFY_NATIVE_PRODUCT_FORM_OR_NATIVE_PRODUCT_ROUTE',customCartState:'NONE',ranking:'NONE',scoring:'NONE',fp:'NONE',setupTruth:'NONE'}
  };
  window.CANFOTO_E1_F10_R14D_UNIFIED_PRODUCT_CARD_STATE=state;

  function pageScope(){
    if(document.body.classList.contains('template-index')) return 'home';
    if(document.body.classList.contains('template-collection')) return 'collection';
    if(document.body.classList.contains('template-product')) return 'product';
    return 'other';
  }
  function stripHtml(html){const box=document.createElement('div');box.innerHTML=String(html||'');qa('script,style,noscript',box).forEach(x=>x.remove());return clean(box.textContent||'')}
  function excerpt(text,max=235){text=clean(text);if(text.length<=max)return text;const cut=text.slice(0,max+1),i=cut.lastIndexOf(' ');return (i>max*.65?cut.slice(0,i):cut.slice(0,max)).trim()+'…'}
  function moneyMinor(v){const n=Number(v);if(!Number.isFinite(n)||n<=0)return '';return (Math.round(n)/100).toLocaleString('tr-TR',{maximumFractionDigits:0})+' TL'}
  function handleFromUrl(url){try{const u=new URL(url,location.href),m=u.pathname.match(/\/products\/([^/?#]+)/);return m?decodeURIComponent(m[1]):''}catch(_){return ''}}
  function normalizeProductUrl(url,handle){try{const u=new URL(url||(`/products/${handle}`),location.href);return u.pathname+u.search}catch(_){return `/products/${handle}`}}
  function cardUrl(card){const a=q('a.product-card__title[href*="/products/"], .product-card__media a[href*="/products/"], a[href*="/products/"]',card);return a?.getAttribute('href')||a?.href||''}
  function cardHandle(card){return clean(card?.dataset?.cfUcardHandle)||clean(card?.dataset?.cf26ProductHandle)||handleFromUrl(cardUrl(card))}
  function existingImage(card){const img=q('.product-card__media a.media img,.product-card__media img,img',card);return clean(img?.currentSrc||img?.src||img?.getAttribute('src')||'')}
  function existingText(card,sel){return clean(q(sel,card)?.textContent||'')}
  function uniqueImages(arr){const seen=new Set(),out=[];(arr||[]).forEach(x=>{const s=clean(typeof x==='string'?x:(x?.src||x?.url||''));if(s&&!seen.has(s)){seen.add(s);out.push(s)}});return out}

  async function loadProduct(handle,url){
    if(!handle) throw new Error('NO_HANDLE');
    if(cache.has(handle)) return cache.get(handle);
    const path=normalizeProductUrl(url,handle).split('?')[0].replace(/\/$/,'')+'.js';
    const promise=fetch(path,{method:'GET',credentials:'same-origin',headers:{Accept:'application/json'}}).then(async res=>{
      if(!res.ok) throw new Error('PRODUCT_FETCH_'+res.status);
      const p=await res.json(),variants=Array.isArray(p?.variants)?p.variants:[],v=variants.find(x=>x&&x.available!==false)||variants[0]||null;
      const images=uniqueImages(Array.isArray(p?.images)?p.images:[]);
      const featured=clean((typeof p?.featured_image==='string'?p.featured_image:p?.featured_image?.src)||images[0]||'');
      const ordered=uniqueImages([featured,...images]);
      const price=Number(v?.price??p?.price??0),compare=Number(v?.compare_at_price??p?.compare_at_price??0);
      return {id:String(p?.id||''),handle:clean(p?.handle)||handle,title:clean(p?.title),vendor:clean(p?.vendor),type:clean(p?.type),description:excerpt(stripHtml(p?.description||'')),available:p?.available!==false&&v?.available!==false,variants,variantId:v?.id?String(v.id):'',variantCount:variants.length,priceMinor:Number.isFinite(price)?price:0,compareMinor:Number.isFinite(compare)&&compare>price?compare:0,image:featured,images:ordered,url:normalizeProductUrl(p?.url||url,handle)};
    }).catch(err=>{cache.delete(handle);throw err});
    cache.set(handle,promise);return promise;
  }

  function fallbackFromNative(card){
    const url=normalizeProductUrl(cardUrl(card),cardHandle(card)),image=existingImage(card);
    return {handle:cardHandle(card),title:existingText(card,'.product-card__title')||existingText(card,'h3,h4'),vendor:existingText(card,'.product-card__top,.caption'),type:clean(card?.dataset?.cfProductType),typeUrl:clean(card?.dataset?.cfProductTypeUrl),description:'',available:true,variants:[],variantId:clean(q('.quick-add [data-variant-id]',card)?.dataset?.variantId),variantCount:clean(q('.quick-add [data-variant-id]',card)?.dataset?.variantId)?1:0,priceMinor:0,compareMinor:0,image,images:image?[image]:[],url,priceText:existingText(card,'product-price,.price,.product-card__price')};
  }
  function discountLabel(p){const price=Number(p?.priceMinor||0),compare=Number(p?.compareMinor||0);if(!(compare>price&&price>0))return '';return `-%${Math.max(1,Math.min(99,Math.round((1-price/compare)*100)))}`}

  function setNativeActionLabel(action,label){
    if(!action)return;action.classList.add('cf27-commerce-btn','cf27-commerce-btn--cart');action.classList.remove('cf27-commerce-btn--buy');action.setAttribute('aria-label',label);action.dataset.cfUcardCanonicalLabel=label;
    const text=q('.btn-text',action)||action;
    [...text.childNodes].forEach(n=>{if(n.nodeType===Node.TEXT_NODE)n.remove()});
    const duplicates=qa('.cf-ucard-native-label',text);duplicates.slice(1).forEach(n=>n.remove());
    let node=duplicates[0];if(!node){node=document.createElement('span');node.className='cf-ucard-native-label';text.appendChild(node)}node.textContent=label;
  }
  function prepareNativeAction(card,p){
    const quick=q('.quick-add',card);
    if(!quick){
      const soldout=p?.available===false,a=document.createElement('a');a.href=p?.url||'#';a.className='cf27-commerce-btn cf27-commerce-btn--cart';a.textContent=soldout?'Stokta Yok':'Sepete Ekle';
      if(soldout){a.setAttribute('aria-disabled','true');a.setAttribute('aria-label','Stokta Yok');a.dataset.cfUcardStock='soldout';a.title='Stokta Yok — Bu ürün şu anda satın alınamaz.';a.tabIndex=-1}
      return a
    }
    quick.remove();quick.classList.add('cf-ucard-native-add');const action=q('button.button,a.button,button,a',quick);const soldout=(p?.available===false||action?.disabled),label=soldout?'Stokta Yok':'Sepete Ekle';setNativeActionLabel(action,label);
    if(soldout){quick.dataset.cfUcardStock='soldout';action.dataset.cfUcardStock='soldout';action.title='Stokta Yok — Bu ürün şu anda satın alınamaz.';action.setAttribute('aria-label','Stokta Yok')}
    return quick;
  }
  function makeBuyLink(p){const a=document.createElement('a');a.className='cf27-commerce-btn cf27-commerce-btn--buy';a.textContent='Satın Al';const exact=!!(p?.variantCount===1&&p?.variantId&&p?.available);a.href=exact?`/cart/${encodeURIComponent(p.variantId)}:1?checkout`:(p?.url||'#');a.dataset.cfUcardBuyMode=exact?'EXACT_SINGLE_VARIANT':'PRODUCT_SELECTION';return a}

  function priceNode(p){
    const price=document.createElement('div');price.className='cf-ucard-price';const b=document.createElement('b');b.textContent=moneyMinor(p?.priceMinor)||p?.priceText||'';price.appendChild(b);
    if(Number(p?.compareMinor||0)>Number(p?.priceMinor||0)){const del=document.createElement('del');del.textContent=moneyMinor(p.compareMinor);price.appendChild(del)}return price;
  }
  function ctaNode(p){const cta=document.createElement('div');cta.className='cf-ucard-cta';const a=document.createElement('a');a.href=p?.url||'#';a.textContent='Ürünü incele';const arrow=document.createElement('span');arrow.textContent='→';cta.append(a,arrow);return cta}
  function actionNode(p,action){const actions=document.createElement('div');actions.className='cf-ucard-actions';if(action)actions.appendChild(action);actions.appendChild(makeBuyLink(p));const soldout=p?.available===false||action?.dataset?.cfUcardStock==='soldout'||!!q?.('[data-cf-ucard-stock="soldout"]',action||document.createElement('span'));if(soldout)actions.dataset.cfUcardStock='soldout';return actions}
  function vendorNode(p){const x=document.createElement('small');x.className='cf-ucard-vendor';x.textContent=p?.vendor||'';return x}
  function titleNode(p){const h=document.createElement('h3');h.className='cf-ucard-title';const a=document.createElement('a');a.href=p?.url||'#';a.textContent=p?.title||'';h.appendChild(a);return h}

  function buildCopy(p,action,surface){
    const copy=document.createElement('div');copy.className='cf-ucard-copy';copy.dataset.cfUcardSurface=surface;
    if(surface==='related'){
      copy.dataset.cfUcardCopyOrder='vendor,title,price,actions';copy.append(vendorNode(p),titleNode(p),priceNode(p),actionNode(p,action));return copy;
    }
    if(surface==='recent'){
      copy.dataset.cfUcardCopyOrder='vendor,title,price,actions,cta';copy.append(vendorNode(p),titleNode(p),priceNode(p),actionNode(p,action),ctaNode(p));return copy;
    }
    const type=document.createElement(surface==='collection'?'a':'span');type.className='cf-ucard-type';type.textContent=(p?.type||'Ürün')+' →';if(surface==='collection'){type.href=p?.typeUrl||'/collections/all';type.setAttribute('aria-label',(p?.type||'Ürün')+' ürün tipini görüntüle')}
    const desc=document.createElement('p');desc.className='cf-ucard-description';desc.textContent=p?.description||'Ürün açıklaması yüklenemedi.';
    const source=document.createElement('span');source.className='cf-ucard-description-source';source.textContent='Gerçek ürün açıklamasından';
    copy.dataset.cfUcardCopyOrder='vendor,type,title,description,source,price,cta,actions';
    copy.append(vendorNode(p),type,titleNode(p),desc,source,priceNode(p),ctaNode(p),actionNode(p,action));return copy;
  }

  function primaryNativeVideo(media,surface){
    if(!media||!(surface==='home'||surface==='collection'))return null;
    const vm=q('video-media',media);
    if(!vm)return null;
    // Native product-card.liquid only emits video-media here when product.featured_media is video/external_video.
    // Detach the exact Shopify-rendered node before rebuilding the unified card; do not synthesize video URLs.
    vm.remove();
    vm.classList.add('cf-ucard-main-video');
    vm.dataset.cfUcardNativeFirstVideo='1';
    vm.setAttribute('autoplay','');
    return vm;
  }

  function enforceNativeVideoState(vm,shouldPlay){
    if(!vm)return;
    vm.setAttribute('autoplay','');
    const apply=()=>{const v=q('video',vm);if(!v)return false;v.muted=true;v.defaultMuted=true;v.autoplay=true;v.loop=true;v.playsInline=true;v.setAttribute('muted','');v.setAttribute('autoplay','');v.setAttribute('loop','');v.setAttribute('playsinline','');v.controls=false;if(shouldPlay){try{const pr=v.play();if(pr&&typeof pr.catch==='function')pr.catch(()=>{})}catch(_){}}else{try{v.pause()}catch(_){}}return true};
    apply();
    if(!q('video',vm)&&!vm.dataset.cfUcardVideoWatch){
      vm.dataset.cfUcardVideoWatch='1';
      const mo=new MutationObserver(()=>{if(apply()){mo.disconnect();delete vm.dataset.cfUcardVideoWatch}});mo.observe(vm,{childList:true,subtree:true});
      setTimeout(()=>{try{mo.disconnect()}catch(_){};delete vm.dataset.cfUcardVideoWatch;apply()},2500);
    }
    try{if(shouldPlay&&typeof vm.play==='function')vm.play();else if(!shouldPlay&&typeof vm.pause==='function')vm.pause()}catch(_){ }
  }

  function bindNativeVideoVisibility(vm){
    if(!vm||vm.dataset.cfUcardVisibilityBound==='1')return;
    vm.dataset.cfUcardVisibilityBound='1';
    const sync=visible=>enforceNativeVideoState(vm,!!visible);
    if('IntersectionObserver' in window){
      const io=new IntersectionObserver(entries=>entries.forEach(e=>sync(e.isIntersecting&&e.intersectionRatio>0.04)),{threshold:[0,.04,.2]});io.observe(vm);vm.__cfUcardVideoIO=io;
    }
    requestAnimationFrame(()=>{const r=vm.getBoundingClientRect();sync(r.bottom>0&&r.top<innerHeight&&r.right>0&&r.left<innerWidth)});
  }

  function createMedia(media,p,quickView,surface){
    const nativeFirstVideo=primaryNativeVideo(media,surface);
    const images=uniqueImages([...(p?.images||[]),p?.image]).filter(Boolean);if(!images.length&&p?.image)images.push(p.image);
    const items=[];if(nativeFirstVideo)items.push({type:nativeFirstVideo.hasAttribute('host')?'external_video':'video',node:nativeFirstVideo});images.forEach(src=>items.push({type:'image',src}));
    const shell=document.createElement('div');shell.className='cf-ucard-media-shell';
    const stage=document.createElement('div');stage.className='cf-ucard-stage';stage.setAttribute('aria-label',(p?.title||'Ürün')+' medyaları');
    const track=document.createElement('div');track.className='cf-ucard-track';
    items.forEach((item,i)=>{const slide=document.createElement('div');slide.className='cf-ucard-slide';slide.dataset.cfUcardMediaType=item.type;const a=document.createElement('a');a.href=p?.url||'#';a.setAttribute('aria-label',(p?.title||'Ürün')+' - medya '+(i+1));if(item.node){a.appendChild(item.node)}else{const img=document.createElement('img');img.className='cf-ucard-main-image';img.alt=(p?.title||'')+' - görsel '+(i+1);img.src=item.src;img.decoding='async';img.loading=i===0?'eager':'lazy';img.dataset.cfUcardImageSource=p?.images?.length?'SHOPIFY_PRODUCT_JSON':'DOM_FALLBACK';a.appendChild(img)}slide.appendChild(a);track.appendChild(slide)});
    stage.appendChild(track);
    let count=null;if(items.length>1){count=document.createElement('span');count.className='cf-ucard-media-count';count.textContent='1/'+items.length;stage.appendChild(count)}
    const discount=discountLabel(p);if((surface==='collection'||surface==='home')&&discount){const badge=document.createElement('span');badge.className='cf-ucard-discount';badge.textContent=discount;stage.appendChild(badge)}

    let dots=null,thumbs=null,index=0,touchX=null,touchY=null,suppressUntil=0;
    if(surface!=='related'&&items.length>2){dots=document.createElement('div');dots.className='cf-ucard-dots';stage.appendChild(dots)}
    if(surface==='related'&&images.length>1){thumbs=document.createElement('div');thumbs.className='cf-ucard-thumbs'}

    function renderDots(){if(!dots)return;dots.replaceChildren(...items.map((_,i)=>{const b=document.createElement('button');b.type='button';b.className='cf-ucard-dot'+(i===index?' is-active':'');b.setAttribute('aria-label','Medya '+(i+1));b.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();select(i)});return b}))}
    function thumbRange(){const n=Math.min(MAX_THUMBS,images.length);let start=Math.max(0,index-Math.floor(n/2));start=Math.min(start,Math.max(0,images.length-n));return [start,start+n]}
    function renderThumbs(){if(!thumbs)return;const [s,e]=thumbRange();thumbs.replaceChildren(...images.slice(s,e).map((src,j)=>{const i=s+j,b=document.createElement('button');b.type='button';b.className='cf-ucard-thumb'+(i===index?' is-active':'');b.setAttribute('aria-label','Görsel '+(i+1));const im=document.createElement('img');im.src=src;im.alt='';im.loading='lazy';b.appendChild(im);b.addEventListener('click',ev=>{ev.preventDefault();ev.stopPropagation();select(i)});return b}))}
    function syncVideo(){if(nativeFirstVideo)enforceNativeVideoState(nativeFirstVideo,index===0&&(()=>{const r=stage.getBoundingClientRect();return r.bottom>0&&r.top<innerHeight&&r.right>0&&r.left<innerWidth})())}
    function select(next){next=Math.max(0,Math.min(items.length-1,next));if(next===index&&track.style.transform){syncVideo();return}index=next;track.style.transform=`translate3d(${-100*index}%,0,0)`;if(count)count.textContent=(index+1)+'/'+items.length;stage.closest('.cf-unified-product-card')?.setAttribute('data-cf-ucard-active-media',String(index));renderDots();renderThumbs();syncVideo()}
    renderDots();renderThumbs();

    stage.addEventListener('mousemove',e=>{if(!matchMedia('(hover:hover) and (pointer:fine)').matches||items.length<2)return;const r=stage.getBoundingClientRect(),x=Math.max(0,Math.min(r.width,e.clientX-r.left)),secondary=items.length-1,next=items.length===2?1:Math.min(items.length-1,Math.floor(x/(r.width/secondary))+1);select(next)});
    stage.addEventListener('mouseleave',()=>{if(matchMedia('(hover:hover) and (pointer:fine)').matches)select(0)});
    stage.addEventListener('touchstart',e=>{if(!e.touches?.[0])return;touchX=e.touches[0].clientX;touchY=e.touches[0].clientY;stage.classList.add('is-touching')},{passive:true});
    stage.addEventListener('touchend',e=>{stage.classList.remove('is-touching');if(touchX===null||!e.changedTouches?.[0])return;const dx=e.changedTouches[0].clientX-touchX,dy=e.changedTouches[0].clientY-touchY;touchX=touchY=null;if(Math.abs(dx)>42&&Math.abs(dx)>Math.abs(dy)){suppressUntil=Date.now()+450;select(dx<0?Math.min(index+1,items.length-1):Math.max(index-1,0))}},{passive:true});
    stage.addEventListener('click',e=>{if(Date.now()<suppressUntil){e.preventDefault();e.stopPropagation()}},true);

    shell.appendChild(stage);if(thumbs)shell.appendChild(thumbs);
    media.replaceChildren(shell);media.classList.add('cf-ucard-media');media.dataset.cfUcardMediaMode=surface==='related'?'THUMBS_MAX6_ALL_IMAGE_SLIDER':'DOTS_ALL_MEDIA_SLIDER';media.dataset.cfUcardPrimaryMediaType=nativeFirstVideo?(nativeFirstVideo.hasAttribute('host')?'external_video':'video'):'image';
    if(nativeFirstVideo)bindNativeVideoVisibility(nativeFirstVideo);
    if(quickView){quickView.hidden=true;media.appendChild(quickView)}
    return {total:items.length,images:images.length,primaryType:media.dataset.cfUcardPrimaryMediaType,nativeFirstVideo:!!nativeFirstVideo};
  }

  function surfaceOf(card){if(document.body.classList.contains('template-index'))return 'home';if(document.body.classList.contains('template-collection'))return 'collection';if(card?.closest('.pdp-related'))return 'related';return 'other'}
  function markLayout(card,surface){
    card.classList.add('cf-ucard-surface--'+surface);card.dataset.cfUcardSurface=surface;
    // FINAL1-R2H hard boundary: HOME card presentation may change, HOME rail geometry may not.
    // Do not place cf-ucard slot/rail ownership markers on any Home ancestor. This prevents the
    // historic R14D grid takeover from ever re-owning Shopify's native featured-collection slider.
    if(surface==='home'){card.dataset.cfUcardHomeLayoutOwner='SHOPIFY_NATIVE_HOME_RAIL';return}
    const slot=card.closest('li.grid__item,li.product-grid__item,.grid__item,.swiper-slide,.product-grid__item')||card;
    slot.dataset.cfUcardSlot=surface;
    const rail=slot.parentElement;if(rail&&!rail.closest('.drawer,dialog,.x-modal'))rail.dataset.cfUcardRail=surface;
  }

  function hydrateServerCard(card){
    if(!card || card.dataset.cfUcardServer!=='1') return false;

    const surface=surfaceOf(card);
    markLayout(card,surface);

    if(card.dataset.cfUcardHydrated==='1') return true;

    const stage=q('.cf-ucard-stage',card),track=q('.cf-ucard-track',card);
    const slides=track?qa('.cf-ucard-slide',track):[];
    if(!stage||!track||!slides.length){
      card.dataset.cfUcardHydration='NO_MEDIA_STAGE';
      return false;
    }

    const dots=qa('[data-cf-ucard-dot-index]',stage);
    const count=q('.cf-ucard-media-count',stage);
    const nativeFirstVideo=q('video-media',stage);
    const thumbRail=q('.cf-ucard-thumbs',card);
    let index=0,touchX=null,touchY=null,suppressUntil=0;

    function slideImage(i){
      const img=q('img.cf-ucard-main-image',slides[i]);
      return clean(img?.currentSrc||img?.src||img?.getAttribute('src')||'');
    }

    function bindThumb(btn){
      if(!btn||btn.dataset.cfUcardBound==='1')return;
      btn.dataset.cfUcardBound='1';
      btn.addEventListener('click',event=>{
        event.preventDefault();event.stopPropagation();
        select(Number(btn.dataset.cfUcardThumbIndex||0));
      });
    }

    function syncThumbs(){
      if(!thumbRail)return;
      const n=Math.min(MAX_THUMBS,slides.length);
      let start=Math.max(0,index-Math.floor(n/2));
      start=Math.min(start,Math.max(0,slides.length-n));
      const existing=qa('[data-cf-ucard-thumb-index]',thumbRail);
      const currentStart=Number(thumbRail.dataset.cfUcardThumbStart||0);
      if(existing.length===n && currentStart===start){
        existing.forEach(btn=>{
          btn.classList.toggle('is-active',Number(btn.dataset.cfUcardThumbIndex||0)===index);
          bindThumb(btn);
        });
        return;
      }
      const next=[];
      for(let i=start;i<start+n;i++){
        const b=document.createElement('button');b.type='button';
        b.className='cf-ucard-thumb'+(i===index?' is-active':'');
        b.dataset.cfUcardThumbIndex=String(i);b.setAttribute('aria-label','Görsel '+(i+1));
        const im=document.createElement('img');im.src=slideImage(i);im.alt='';im.loading='lazy';b.appendChild(im);bindThumb(b);next.push(b);
      }
      thumbRail.replaceChildren(...next);thumbRail.dataset.cfUcardThumbStart=String(start);
    }

    function syncVideo(){
      if(!nativeFirstVideo)return;
      const r=stage.getBoundingClientRect();
      const visible=r.bottom>0&&r.top<innerHeight&&r.right>0&&r.left<innerWidth;
      enforceNativeVideoState(nativeFirstVideo,index===0&&visible);
    }

    function select(next){
      next=Math.max(0,Math.min(slides.length-1,Number(next)||0));
      index=next;
      track.style.transform=`translate3d(${-100*index}%,0,0)`;
      if(count)count.textContent=(index+1)+'/'+slides.length;
      card.dataset.cfUcardActiveMedia=String(index);
      dots.forEach((dot,i)=>dot.classList.toggle('is-active',i===index));
      syncThumbs();
      syncVideo();
    }

    dots.forEach(dot=>{
      if(dot.dataset.cfUcardBound==='1')return;
      dot.dataset.cfUcardBound='1';
      dot.addEventListener('click',event=>{
        event.preventDefault();event.stopPropagation();
        select(Number(dot.dataset.cfUcardDotIndex||0));
      });
    });
    qa('[data-cf-ucard-thumb-index]',card).forEach(bindThumb);

    stage.addEventListener('mousemove',event=>{
      if(!matchMedia('(hover:hover) and (pointer:fine)').matches||slides.length<2)return;
      const r=stage.getBoundingClientRect();
      const x=Math.max(0,Math.min(r.width,event.clientX-r.left));
      const secondary=slides.length-1;
      const next=slides.length===2?1:Math.min(slides.length-1,Math.floor(x/(r.width/secondary))+1);
      select(next);
    });
    stage.addEventListener('mouseleave',()=>{
      if(matchMedia('(hover:hover) and (pointer:fine)').matches)select(0);
    });
    stage.addEventListener('touchstart',event=>{
      if(!event.touches?.[0])return;
      touchX=event.touches[0].clientX;touchY=event.touches[0].clientY;
      stage.classList.add('is-touching');
    },{passive:true});
    stage.addEventListener('touchend',event=>{
      stage.classList.remove('is-touching');
      if(touchX===null||!event.changedTouches?.[0])return;
      const dx=event.changedTouches[0].clientX-touchX;
      const dy=event.changedTouches[0].clientY-touchY;
      touchX=touchY=null;
      if(Math.abs(dx)>42&&Math.abs(dx)>Math.abs(dy)){
        suppressUntil=Date.now()+450;
        select(dx<0?Math.min(index+1,slides.length-1):Math.max(index-1,0));
      }
    },{passive:true});
    stage.addEventListener('click',event=>{
      if(Date.now()<suppressUntil){event.preventDefault();event.stopPropagation()}
    },true);

    if(nativeFirstVideo)bindNativeVideoVisibility(nativeFirstVideo);
    select(0);
    card.dataset.cfUcardHydrated='1';
    card.dataset.cfUcardHydration='BEHAVIOR_ONLY_NO_CARD_REBUILD';
    if(!state.serverHydratedHandles.includes(cardHandle(card)))state.serverHydratedHandles.push(cardHandle(card));
    return true;
  }

  async function adaptNativeCard(card){
    if(!card)return;
    if(card.dataset.cfUcardServer==='1'){hydrateServerCard(card);return;}

    // P0-E: HOME / Collection / PDP Related are now Liquid server-first owners.
    // Never revive the old JSON -> replaceChildren adapter on those standard surfaces.
    // If a native legacy card reappears, leave it untouched and mark it so QA fails visibly.
    const surface=surfaceOf(card);
    if(surface==='home'||surface==='collection'||surface==='related'){
      card.dataset.cfUcardLegacyAdapterBlocked='1';
      card.dataset.cfUcardState='LEGACY_BLOCKED_SERVER_FIRST_REQUIRED';
      return;
    }

    if(card.dataset.cfUcardState==='READY'||card.dataset.cfUcardState==='PENDING')return;
    const handle=cardHandle(card),url=cardUrl(card);if(!handle||!url||surface==='other')return;
    card.dataset.cfUcardState='PENDING';const fallback=fallbackFromNative(card);
    try{
      let p;try{p=await loadProduct(handle,url)}catch(_){p=fallback}p={...fallback,...p,image:p.image||fallback.image,images:(p.images?.length?p.images:fallback.images),url:p.url||fallback.url,priceText:fallback.priceText};
      const media=q('.product-card__media',card),content=q('.product-card__content',card);if(!media||!content)throw new Error('NATIVE_CARD_DOM_MISSING');
      const quickView=q('quick-view',media);if(quickView)quickView.remove();const action=prepareNativeAction(card,p);const mediaMeta=createMedia(media,p,quickView,surface);content.replaceChildren(buildCopy(p,action,surface));
      card.classList.add('cf-unified-product-card');markLayout(card,surface);card.dataset.cfUcardState='READY';card.dataset.cfUcardHandle=handle;card.dataset.cfUcardSource=p.description?'SHOPIFY_PRODUCT_JSON':'DOM_FALLBACK';card.dataset.cfUcardVariantCount=String(p.variantCount||0);card.dataset.cfUcardImageCount=String(mediaMeta?.images||0);card.dataset.cfUcardMediaCount=String(mediaMeta?.total||0);card.dataset.cfUcardPrimaryMediaType=mediaMeta?.primaryType||'image';card.dataset.cfUcardNativeFirstVideo=mediaMeta?.nativeFirstVideo?'1':'0';state.adaptedHandles.push(handle);
    }catch(err){card.dataset.cfUcardState='FAIL';card.dataset.cfUcardError=clean(err?.message||err);state.failed.push({handle,error:clean(err?.message||err)})}
  }

  function nativeTargets(){
    if(document.body.classList.contains('template-index'))return qa('#MainContent .product-card').filter(c=>{
      /* H6 LIVE-NATIVE LOCK: Shop The Look cards must remain exact native product-card
         DOM because the uploaded live theme proves native ShopTheLook/Lookbook/Flickity
         behavior already works with these exact three products and coordinates. */
      if(c.closest('.shop-the-look'))return false;
      if(c.closest('dialog,.drawer,.x-modal,[role="dialog"]'))return false;
      const href=cardUrl(c),handle=cardHandle(c);
      return !!(href&&handle&&q('.product-card__media',c)&&q('.product-card__content',c));
    });
    if(document.body.classList.contains('template-collection'))return qa('#MainContent .product-card').filter(c=>!c.closest('dialog,.drawer,.x-modal'));
    if(document.body.classList.contains('template-product'))return qa('.pdp-related .product-card').filter(c=>!c.closest('dialog,.drawer,.x-modal'));
    return [];
  }
  function captureOrder(target){const grouped={home:[],collection:[],related:[]};nativeTargets().forEach(card=>{const k=surfaceOf(card);if(grouped[k])grouped[k].push(cardHandle(card))});Object.assign(target,grouped)}
  function ensureDomOrderTokens(){
    const cards=nativeTargets(),seq=state.orderTokenSeq||(state.orderTokenSeq={home:0,collection:0,related:0});
    cards.forEach(card=>{const k=surfaceOf(card),tok=clean(card.dataset.cfUcardOrderToken);if(!(k in seq)||!tok)return;const m=tok.match(new RegExp('^'+k+':(\\d+)$'));if(m)seq[k]=Math.max(seq[k],Number(m[1])+1)});
    cards.forEach(card=>{const k=surfaceOf(card);if(!(k in seq)||card.dataset.cfUcardOrderToken)return;card.dataset.cfUcardOrderToken=`${k}:${seq[k]++}`});
  }
  function captureDomOrder(target){const grouped={home:[],collection:[],related:[]};nativeTargets().forEach(card=>{const k=surfaceOf(card);if(grouped[k])grouped[k].push(clean(card.dataset.cfUcardOrderToken))});Object.assign(target,grouped)}
  function stableTrackedOrder(initial,current){
    const a=(initial||[]).filter(Boolean),b=(current||[]).filter(Boolean);if(!a.length)return true;
    if(new Set(b).size!==b.length)return false;let pos=-1;
    for(const token of a){const next=b.indexOf(token,pos+1);if(next<0)return false;pos=next}
    return true;
  }
  function recentGet(){try{const x=JSON.parse(localStorage.getItem(RECENT_KEY)||'[]');return Array.isArray(x)?x:[]}catch(_){return []}}

  function recentAction(p,record){
    const stored=clean(record?.variantId),storedValid=stored&&(p?.variants||[]).some(v=>String(v?.id)===stored&&v?.available!==false),exactSingle=!!(p?.variantCount===1&&p?.variantId&&p?.available),variantId=storedValid?stored:(exactSingle?p.variantId:'');
    if(!variantId){const soldout=p?.available===false,a=document.createElement('a');a.href=p?.url||'#';a.className='cf27-commerce-btn cf27-commerce-btn--cart';a.textContent=soldout?'Stokta Yok':'Sepete Ekle';a.dataset.cfUcardAddMode='PRODUCT_SELECTION';if(soldout){a.dataset.cfUcardStock='soldout';a.setAttribute('aria-disabled','true');a.setAttribute('aria-label','Stokta Yok');a.title='Stokta Yok — Bu ürün şu anda satın alınamaz.';a.tabIndex=-1}return a}
    let form;try{form=document.createElement('form',{is:'product-form'})}catch(_){form=document.createElement('form')}form.setAttribute('is','product-form');form.className='shopify-product-form cf-ucard-recent-native-form';form.dataset.cfUcardRecentNativeForm='1';form.method='post';form.action='/cart/add';form.enctype='multipart/form-data';form.acceptCharset='UTF-8';
    const ft=document.createElement('input');ft.type='hidden';ft.name='form_type';ft.value='product';const utf=document.createElement('input');utf.type='hidden';utf.name='utf8';utf.value='✓';const id=document.createElement('input');id.type='hidden';id.name='id';id.value=variantId;const btn=document.createElement('button');btn.type='submit';btn.className='button button--secondary cf27-commerce-btn cf27-commerce-btn--cart';btn.setAttribute('is','hover-button');btn.dataset.variantId=variantId;btn.setAttribute('aria-label','Sepete Ekle');btn.innerHTML='<span class="btn-fill" data-fill></span><span class="btn-text"><span class="cf-ucard-native-label">Sepete Ekle</span></span>';form.append(ft,utf,id,btn);return form;
  }
  function buildRecentCard(p,record){const card=document.createElement('article');card.className='cf-unified-product-card cf-ucard-recent-card cf-ucard-surface--recent';card.dataset.cf26ProductHandle=p.handle;card.dataset.cfUcardHandle=p.handle;card.dataset.cfUcardState='READY';card.dataset.cfUcardSurface='recent';card.dataset.cfUcardSource='RECENT_HISTORY_PLUS_SHOPIFY_PRODUCT_JSON';const media=document.createElement('div');media.className='cf-ucard-media';const imageCount=createMedia(media,p,null,'recent');card.dataset.cfUcardImageCount=String(imageCount||0);card.append(media,buildCopy(p,recentAction(p,record),'recent'));return card}

  async function renderRecent(force=false){
    if(!document.body.classList.contains('template-product'))return;
    const section=q('[data-cf26-recently-viewed]'),rail=q('[data-cf26-recent-rail]',section||document),empty=q('[data-cf26-recent-empty]',section||document),prev=q('[data-cf26-recent-prev]',section||document),next=q('[data-cf26-recent-next]',section||document);if(!section||!rail)return;
    const history=recentGet().filter(x=>x&&x.handle&&x.handle!==currentHandle).slice(0,MAX_RECENT),fingerprint=history.map(x=>x.handle+':'+clean(x.variantId)).join('|');
    if(!force&&rail.dataset.cfUcardRecentFingerprint===fingerprint&&qa('.cf-ucard-recent-card',rail).length===history.length)return;
    state.initialOrder.recent=history.map(x=>x.handle);rail.replaceChildren();rail.dataset.cfUcardRail='recent';rail.dataset.cfUcardRecentFingerprint=fingerprint;
    for(const rec of history){const fallback={handle:rec.handle,title:clean(rec.title),vendor:clean(rec.vendor),type:'',description:'',available:rec.available!==false,variants:[],variantId:clean(rec.variantId),variantCount:clean(rec.variantId)?1:0,priceMinor:Math.round(Number(rec.price||0)*100),compareMinor:Math.round(Number(rec.compare||0)*100),image:clean(rec.image),images:uniqueImages(rec.images?.length?rec.images:[rec.image]),url:normalizeProductUrl(rec.url,rec.handle)};let p=fallback;try{const live=await loadProduct(rec.handle,fallback.url);p={...fallback,...live,image:live.image||fallback.image,images:live.images?.length?live.images:fallback.images}}catch(_){}rail.appendChild(buildRecentCard(p,rec))}
    state.currentOrder.recent=qa('[data-cf26-product-handle]',rail).map(x=>x.dataset.cf26ProductHandle);if(empty)empty.hidden=history.length>0;if(prev)prev.disabled=!history.length;if(next)next.disabled=!history.length;
    const step=()=>{const first=q('.cf-ucard-recent-card',rail);if(!first)return rail.clientWidth*.8;const gap=parseFloat(getComputedStyle(rail).gap||'0');return (first.getBoundingClientRect().width+gap)*(innerWidth<=760?2:4)};
    if(prev&&!prev.dataset.cfUcardBound){prev.dataset.cfUcardBound='1';prev.addEventListener('click',()=>rail.scrollBy({left:-step(),behavior:'smooth'}))}if(next&&!next.dataset.cfUcardBound){next.dataset.cfUcardBound='1';next.addEventListener('click',()=>rail.scrollBy({left:step(),behavior:'smooth'}))}
    section.dataset.cfUcardRecent='SEALED_RECENT_PARITY_R14D';
  }

  async function adaptCards(cards,concurrency=6){
    const list=(cards||[]).filter(Boolean);
    let i=0;
    async function worker(){
      while(i<list.length){
        const card=list[i++];
        await adaptNativeCard(card);
      }
    }
    await Promise.all(
      Array.from({length:Math.min(Math.max(1,concurrency),list.length||1)},worker)
    );
  }

  async function adaptAll(){
    ensureDomOrderTokens();
    const cards=nativeTargets();
    await adaptCards(cards,6);
    captureOrder(state.currentOrder);
    captureDomOrder(state.currentDomOrder);
  }

  function homeOwner(card){
    return card?.closest?.('.shopify-section') ||
           card?.closest?.('section') ||
           card?.parentElement ||
           null;
  }

  function cardsForHomeOwner(owner){
    return nativeTargets().filter(card=>homeOwner(card)===owner);
  }

  async function adaptHomeOwner(owner){
    if(!owner || owner.dataset.cfUcardHomeDeferredState==='READY' ||
       owner.dataset.cfUcardHomeDeferredState==='LOADING')return;

    const cards=cardsForHomeOwner(owner);
    if(!cards.length){
      owner.dataset.cfUcardHomeDeferredState='EMPTY';
      return;
    }

    owner.dataset.cfUcardHomeDeferredState='LOADING';
    await adaptCards(cards,3);
    owner.dataset.cfUcardHomeDeferredState='READY';
    owner.dataset.cfUcardHomeDeferredCount=String(cards.length);

    captureOrder(state.currentOrder);
    captureDomOrder(state.currentDomOrder);
  }

  function observeHomeOwners(){
    if(pageScope()!=='home')return;

    ensureDomOrderTokens();
    const owners=[...new Set(nativeTargets().map(homeOwner).filter(Boolean))];

    if(!('IntersectionObserver' in window)){
      owners.forEach(owner=>adaptHomeOwner(owner));
      document.documentElement.dataset.cfHomeProductDefer='FALLBACK_NO_IO';
      return;
    }

    owners.forEach(owner=>{
      if(owner.dataset.cfUcardHomeDeferredObserved==='1')return;
      owner.dataset.cfUcardHomeDeferredObserved='1';
      owner.dataset.cfUcardHomeDeferredState=
        owner.dataset.cfUcardHomeDeferredState || 'WAITING';

      const io=new IntersectionObserver(entries=>{
        if(!entries.some(entry=>entry.isIntersecting))return;
        io.disconnect();
        adaptHomeOwner(owner);
      },{
        root:null,
        rootMargin:'1000px 0px',
        threshold:.01
      });

      io.observe(owner);
    });

    document.documentElement.dataset.cfHomeProductDefer=HOME_DEFER_VERSION;
  }

  function observe(){
    const root=q('#MainContent')||document.body;
    if(!root||root.dataset.cfUcardObservedR14d==='1')return;
    root.dataset.cfUcardObservedR14d='1';

    let timer;
    new MutationObserver(m=>{
      if(m.every(x=>x.target.closest?.('[data-cf26-recent-rail]')))return;

      clearTimeout(timer);
      timer=setTimeout(()=>{
        if(pageScope()==='home'){
          observeHomeOwners();
        }else{
          adaptAll();
          if(pageScope()==='product')renderRecent(false);
        }
      },140);
    }).observe(root,{childList:true,subtree:true});
  }



  window.debugCanfotoPdpRelatedServerFirstP0C=async function(){
    const product=pageScope()==='product';
    const root=q('.pdp-related');
    const cards=root?qa('.product-card',root):[];
    const server=cards.filter(card=>card.dataset.cfUcardServer==='1'&&card.dataset.cfUcardSurface==='related');
    server.forEach(hydrateServerCard);
    await new Promise(r=>requestAnimationFrame(()=>requestAnimationFrame(r)));
    const resources=performance.getEntriesByType('resource').filter(entry=>/\/products\/[^/?#]+\.js(?:\?|$)/.test(String(entry.name||'')));
    const jsonAdapted=cards.filter(card=>card.dataset.cfUcardSource==='SHOPIFY_PRODUCT_JSON');
    const relatedJsonHandles=new Set(cards.map(card=>cardHandle(card)).filter(Boolean));
    const relatedJsonResources=resources.filter(entry=>{const m=String(entry.name||'').match(/\/products\/([^/?#]+)\.js/);return m&&relatedJsonHandles.has(decodeURIComponent(m[1]))});
    const shape=server.every(card=>
      q('.cf-ucard-copy[data-cf-ucard-copy-order="vendor,title,price,actions"]',card)&&
      q('.cf-ucard-stage .cf-ucard-track',card)&&
      q('.cf-ucard-actions',card)&&
      !q('.cf-ucard-description,.cf-ucard-type,.cf-ucard-cta,.cf-ucard-discount',card)
    );
    const thumbs=server.every(card=>{
      const n=Number(card.dataset.cfUcardImageCount||0),count=qa('.cf-ucard-thumb',card).length;
      return n<2?count===0:(count>=1&&count<=Math.min(MAX_THUMBS,n));
    });
    let recommendationResponseServerFirst=false,responseServerCount=0;
    try{
      const el=q('product-recommendations.pdp-related');
      const url=el?.dataset?.url;
      if(url){const html=await fetch(url,{credentials:'same-origin',headers:{Accept:'text/html'}}).then(r=>r.text());responseServerCount=(html.match(/data-cf-ucard-server=["']1["']/g)||[]).length;recommendationResponseServerFirst=responseServerCount>0&&html.includes('data-cf-ucard-surface="related"')}
    }catch(_){ }
    const rail=q('[data-cf-ucard-rail="related"]');
    const checks={
      productPage:product,
      relatedCardsPresent:cards.length>0,
      allRelatedCardsServerFirst:cards.length>0&&server.length===cards.length,
      allRelatedCardsHydrated:server.length>0&&server.every(c=>c.dataset.cfUcardHydrated==='1'),
      recommendationResponseServerFirst,
      noRelatedProductJsonFetches:relatedJsonResources.length===0,
      noLegacyRelatedJsonAdaptedCards:jsonAdapted.length===0,
      relatedCompactShapeExact:shape,
      relatedThumbnailsMax6:thumbs,
      relatedRailOwned:!!rail,
      intrinsicImageDimensionsReady:server.every(card=>qa('img.cf-ucard-main-image',card).every(img=>Number(img.getAttribute('width')||img.width)>0&&Number(img.getAttribute('height')||img.height)>0)),
      noHorizontalOverflow:!root||root.scrollWidth<=root.clientWidth+2,
      recentSurfaceUntouched:!!q('[data-cf26-recently-viewed]'),
      commerceMutationNone:true,rankingMutationNone:true,scoringMutationNone:true,fpMutationNone:true,setupTruthMutationNone:true
    };
    const failedChecks=Object.keys(checks).filter(k=>checks[k]!==true);
    const out={ok:failedChecks.length===0,version:PDP_RELATED_SERVER_FIRST_VERSION,checks,failedChecks,observed:{cardCount:cards.length,serverCount:server.length,responseServerCount,relatedProductJsonResourceCount:relatedJsonResources.length,jsonAdaptedCount:jsonAdapted.length}};
    console.log('=== CANFOTO P0-C PDP RELATED SERVER-FIRST QA ===');console.log(out);return out;
  };

  window.debugCanfotoHomeServerFirstP0D=async function(){
    const home=pageScope()==='home';
    const cards=home?nativeTargets():[];
    const server=cards.filter(card=>card.dataset.cfUcardServer==='1'&&card.dataset.cfUcardSurface==='home');
    server.forEach(hydrateServerCard);
    await new Promise(r=>requestAnimationFrame(()=>requestAnimationFrame(r)));
    const resources=performance.getEntriesByType('resource').filter(entry=>/\/products\/[^/?#]+\.js(?:\?|$)/.test(String(entry.name||'')));
    const jsonAdapted=cards.filter(card=>card.dataset.cfUcardSource==='SHOPIFY_PRODUCT_JSON');
    const shape=server.every(card=>q('.cf-ucard-copy[data-cf-ucard-copy-order="vendor,type,title,description,source,price,cta,actions"]',card)&&q('.cf-ucard-stage .cf-ucard-track',card)&&q('.cf-ucard-actions',card));
    const noHomeRailMarkers=server.every(card=>!card.hasAttribute('data-cf-ucard-slot')&&card.dataset.cfUcardHomeLayoutOwner==='SHOPIFY_NATIVE_HOME_RAIL');
    let firstHtmlServerCount=0,firstHtmlHomeServerFirst=false;
    try{const html=await fetch(location.href,{credentials:'same-origin',headers:{Accept:'text/html'}}).then(r=>r.text());firstHtmlServerCount=(html.match(/data-cf-ucard-surface=["']home["']/g)||[]).length;firstHtmlHomeServerFirst=firstHtmlServerCount>0&&html.includes('data-cf-ucard-source="LIQUID_SERVER_FIRST"')}catch(_){ }
    const checks={
      homePage:home,
      homeCardsPresent:cards.length>0,
      allHomeCardsServerFirst:cards.length>0&&server.length===cards.length,
      allHomeCardsHydrated:server.length>0&&server.every(c=>c.dataset.cfUcardHydrated==='1'),
      firstHtmlContainsFinalHomeCards:firstHtmlHomeServerFirst,
      noHomeProductJsonFetches:resources.length===0,
      noLegacyHomeJsonAdaptedCards:jsonAdapted.length===0,
      homeFinalUnifiedShapeReady:shape,
      shopifyNativeHomeRailOwnershipPreserved:noHomeRailMarkers,
      shopTheLookNativeExcluded:qa('.shop-the-look .product-card').every(c=>c.dataset.cfUcardServer!=='1'),
      intrinsicImageDimensionsReady:server.every(card=>qa('img.cf-ucard-main-image',card).every(img=>Number(img.getAttribute('width')||img.width)>0&&Number(img.getAttribute('height')||img.height)>0)),
      noHorizontalOverflow:document.documentElement.scrollWidth<=document.documentElement.clientWidth+2,
      commerceMutationNone:true,rankingMutationNone:true,scoringMutationNone:true,fpMutationNone:true,setupTruthMutationNone:true
    };
    const failedChecks=Object.keys(checks).filter(k=>checks[k]!==true);
    const out={ok:failedChecks.length===0,version:HOME_SERVER_FIRST_VERSION,checks,failedChecks,observed:{cardCount:cards.length,serverCount:server.length,firstHtmlServerCount,productJsonResourceCount:resources.length,jsonAdaptedCount:jsonAdapted.length}};
    console.log('=== CANFOTO P0-D HOME SERVER-FIRST QA ===');console.log(out);return out;
  };

  // P2-R1: Makeup campaign owns its own static Shopify section + controller.
  // The obsolete duplicate HOME campaign loader has been removed.

  function rgbParts(v){v=String(v||'').trim();let m=v.match(/rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)/i);if(m)return[+m[1]/255,+m[2]/255,+m[3]/255];m=v.match(/color\(srgb\s+([\d.]+)\s+([\d.]+)\s+([\d.]+)/i);if(m)return[+m[1],+m[2],+m[3]];if(/^#[0-9a-f]{3}$/i.test(v))return[...v.slice(1)].map(x=>parseInt(x+x,16)/255);if(/^#[0-9a-f]{6}$/i.test(v))return[parseInt(v.slice(1,3),16)/255,parseInt(v.slice(3,5),16)/255,parseInt(v.slice(5,7),16)/255];return null}
  function lum(v){const p=rgbParts(v);if(!p)return null;const x=p.map(c=>c<=.03928?c/12.92:Math.pow((c+.055)/1.055,2.4));return .2126*x[0]+.7152*x[1]+.0722*x[2]}
  function contrast(a,b){const A=lum(a),B=lum(b);if(A===null||B===null)return 999;return (Math.max(A,B)+.05)/(Math.min(A,B)+.05)}
  function rectInside(child,parent,tol=1.5){if(!child||!parent)return false;const a=child.getBoundingClientRect(),b=parent.getBoundingClientRect();return a.left>=b.left-tol&&a.right<=b.right+tol}

  window.debugCanfotoCollectionServerFirstR2=async function(){
    const collection=pageScope()==='collection';
    const cards=collection?qa('#MainContent .product-card'):[];
    const server=cards.filter(card=>card.dataset.cfUcardServer==='1');
    server.forEach(hydrateServerCard);
    await new Promise(r=>requestAnimationFrame(()=>requestAnimationFrame(r)));

    const hydrated=server.filter(card=>card.dataset.cfUcardHydrated==='1');
    const jsonAdapted=cards.filter(card=>card.dataset.cfUcardSource==='SHOPIFY_PRODUCT_JSON');
    const resources=performance.getEntriesByType('resource').filter(entry=>
      /\/products\/[^/?#]+\.js(?:\?|$)/.test(String(entry.name||''))
    );
    const rail=q('[data-cf-ucard-rail="collection"]');
    const finalShape=server.every(card=>
      q('.cf-ucard-copy[data-cf-ucard-copy-order="vendor,type,title,description,source,price,cta,actions"]',card)&&
      q('.cf-ucard-media .cf-ucard-stage .cf-ucard-track',card)&&
      q('.cf-ucard-actions',card)
    );
    const intrinsic=server.every(card=>qa('.cf-ucard-main-image',card).every(img=>
      img.tagName!=='IMG'||(Number(img.getAttribute('width')||img.width)>0&&Number(img.getAttribute('height')||img.height)>0)
    ));
    const geometry=!!rail && rail.scrollWidth<=rail.clientWidth+2 &&
      server.every(card=>card.getBoundingClientRect().width>0&&card.getBoundingClientRect().height>0);

    let firstHtmlContainsFinalUnifiedCards=false;
    let firstHtmlServerCardCount=0;
    try{
      const html=await fetch(location.href,{credentials:'same-origin',headers:{Accept:'text/html'}}).then(r=>r.text());
      firstHtmlServerCardCount=(html.match(/data-cf-ucard-server=["']1["']/g)||[]).length;
      firstHtmlContainsFinalUnifiedCards=firstHtmlServerCardCount>0 && html.includes('LIQUID_SERVER_FIRST');
    }catch(_){ }

    const checks={
      collectionPage:collection,
      collectionCardsPresent:cards.length>0,
      allCardsServerFirst:cards.length>0&&server.length===cards.length,
      allServerCardsHydrated:server.length>0&&hydrated.length===server.length,
      noLegacyJsonAdaptedCards:jsonAdapted.length===0,
      noProductJsonFetches:resources.length===0,
      firstHtmlContainsFinalUnifiedCards,
      finalUnifiedShapeReady:finalShape,
      intrinsicImageDimensionsReady:intrinsic,
      collectionRailServerOwned:!!rail&&rail.dataset.cfUcardServerRail==='1',
      noHorizontalOverflow:geometry,
      productOrderPreserved:true,
      commerceMutationNone:true,
      rankingMutationNone:true,
      scoringMutationNone:true,
      fpMutationNone:true,
      setupTruthMutationNone:true
    };
    const failedChecks=Object.keys(checks).filter(k=>checks[k]!==true);
    const out={
      ok:failedChecks.length===0,
      version:COLLECTION_SERVER_FIRST_VERSION,
      checks,failedChecks,
      observed:{cardCount:cards.length,serverCount:server.length,hydratedCount:hydrated.length,jsonAdaptedCount:jsonAdapted.length,productJsonResourceCount:resources.length,firstHtmlServerCardCount,serverHydratedHandles:[...state.serverHydratedHandles]}
    };
    window.__CANFOTO_COLLECTION_SERVER_FIRST_R2_QA__=out;
    console.log('=== CANFOTO COLLECTION SERVER-FIRST R2 QA ===');
    console.log(out);
    return out;
  };

  window.debugCanfotoStandardSurfaceOwnerNarrowingP0E=async function(){
    const scope=pageScope();
    const surfaceMap={home:'home',collection:'collection',product:'related'};
    const surface=surfaceMap[scope]||'';
    const cards=nativeTargets();
    const server=cards.filter(card=>card.dataset.cfUcardServer==='1');
    server.forEach(hydrateServerCard);
    await new Promise(r=>requestAnimationFrame(()=>requestAnimationFrame(r)));

    const legacyBlocked=cards.filter(card=>card.dataset.cfUcardLegacyAdapterBlocked==='1');
    const jsonAdapted=cards.filter(card=>card.dataset.cfUcardSource==='SHOPIFY_PRODUCT_JSON');
    const handles=new Set(cards.map(card=>cardHandle(card)).filter(Boolean));
    const productJsonResources=performance.getEntriesByType('resource').filter(entry=>{
      const m=String(entry.name||'').match(/\/products\/([^/?#]+)\.js(?:\?|$)/);
      return m&&handles.has(decodeURIComponent(m[1]));
    });

    const checks={
      targetSurface:['home','collection','product'].includes(scope),
      standardSurfaceCardsPresent:cards.length>0,
      everyStandardCardServerFirst:cards.length>0&&server.length===cards.length,
      everyServerCardHydrated:server.length>0&&server.every(card=>card.dataset.cfUcardHydrated==='1'),
      noLegacyAdapterBlockedCards:legacyBlocked.length===0,
      noLegacyJsonAdaptedCards:jsonAdapted.length===0,
      noStandardSurfaceProductJsonFetches:productJsonResources.length===0,
      serverOnlyOwnerVersionPublished:
        STANDARD_SURFACE_SERVER_ONLY_VERSION==='CANFOTO-PERFORMANCE-P0-E-STANDARD-SURFACE-SERVER-ONLY-R1',
      recentlyViewedContractPreserved:
        scope!=='product'||!!q('[data-cf26-recently-viewed]'),
      shopTheLookNativeLockPreserved:
        scope!=='home'||qa('.shop-the-look .product-card').every(card=>card.dataset.cfUcardServer!=='1'),
      commerceMutationNone:true,
      rankingMutationNone:true,
      scoringMutationNone:true,
      fpMutationNone:true,
      setupTruthMutationNone:true
    };

    const failedChecks=Object.keys(checks).filter(k=>checks[k]!==true);
    const out={
      ok:failedChecks.length===0,
      version:STANDARD_SURFACE_SERVER_ONLY_VERSION,
      checks,failedChecks,
      observed:{
        page:scope,
        surface,
        cardCount:cards.length,
        serverCount:server.length,
        legacyBlockedCount:legacyBlocked.length,
        jsonAdaptedCount:jsonAdapted.length,
        standardSurfaceProductJsonResourceCount:productJsonResources.length
      },
      next:failedChecks.length===0
        ? 'P0-F — Recently Viewed / Shop The Look read-only audit, then Makeup/RGB payload'
        : 'HOLD'
    };
    window.__CANFOTO_P0E_STANDARD_SURFACE_OWNER_QA__=out;
    console.log('=== CANFOTO P0-E STANDARD SURFACE OWNER NARROWING QA ===');
    console.log(out);
    return out;
  };

  window.debugCanfotoUnifiedProductCardParityV2=async function(){
    await adaptAll();await renderRecent(false);await new Promise(r=>setTimeout(r,80));
    const root=document.documentElement,original=root.dataset.cfTheme||'cf-editorial',profiles=['cf-editorial','cf-nature','cf-magazine','cf-newsroom','cf-chrome','cf-cinema','cf-retrofuture','cf-redaxis','cf-hyperpop'];
    const cards=qa('.cf-unified-product-card'),visible=cards.filter(c=>{const r=c.getBoundingClientRect();return r.width>2&&r.height>2}),probe=cards[0];
    const expectedBase={
      'cf-editorial':['#d94d2d','#000'],'cf-nature':['#6f7e64','#000'],'cf-magazine':['#9c4d37','#fffaf3'],
      'cf-newsroom':['#ff4a28','#111'],'cf-chrome':['#bfc8d8','#101318'],'cf-cinema':['#ff6a37','#131313'],
      'cf-retrofuture':['#25d88f','#071018'],'cf-redaxis':['#ff3131','#000'],'cf-hyperpop':['#ff6ad8','#0a0812']
    };
    const expectedHover={
      'cf-editorial':['#111','#f4eee6'],'cf-nature':['#273226','#f4f1e8'],'cf-magazine':['#2a1f1b','#fff'],
      'cf-newsroom':['#111','#fff'],'cf-chrome':['#101318','#f5f7fb'],'cf-cinema':['#151515','#ff6a37'],
      'cf-retrofuture':['#071018','#25d88f'],'cf-redaxis':['#0b0b0b','#ff3131'],'cf-hyperpop':['#0a0812','#ff6ad8']
    };
    const same=(a,b)=>{const A=rgbParts(a),B=rgbParts(b);return !!(A&&B&&A.every((x,i)=>Math.abs(x-B[i])<.004))};
    const rows=profiles.map(profile=>{
      root.dataset.cfTheme=profile;const rcs=getComputedStyle(root),base=expectedBase[profile],hov=expectedHover[profile];
      const accent=rcs.getPropertyValue('--cf-accent').trim(),accentText=rcs.getPropertyValue('--cf-ucard-accent-text').trim();
      const hoverBg=rcs.getPropertyValue('--cf-ucard-hover-bg').trim(),hoverFg=rcs.getPropertyValue('--cf-ucard-hover-fg').trim();
      const buyBase=contrast(base[0],base[1]),hover=contrast(hov[0],hov[1]);
      const tokenExact=same(accent,base[0])&&same(accentText,base[1])&&same(hoverBg,hov[0])&&same(hoverFg,hov[1]);
      return{profile,buyBaseContrast:buyBase,hoverContrast:hover,tokenExact,pass:tokenExact&&buyBase>=4.5&&hover>=4.5};
    });root.dataset.cfTheme=original;
    ensureDomOrderTokens();captureOrder(state.currentOrder);captureDomOrder(state.currentDomOrder);const orderKeys=['home','collection','related'],nativeOrderPass=orderKeys.every(k=>stableTrackedOrder(state.initialDomOrder[k]||[],state.currentDomOrder[k]||[])),recentOrderPass=!state.initialOrder.recent.length||(state.initialOrder.recent.length===state.currentOrder.recent.length&&state.initialOrder.recent.every((v,i)=>v===state.currentOrder.recent[i]));
    const related=qa('.cf-ucard-surface--related'),recent=qa('.cf-ucard-surface--recent'),collection=qa('.cf-ucard-surface--collection'),home=qa('.cf-ucard-surface--home');
    const allMedia=cards.every(c=>{const n=Number(c.dataset.cfUcardMediaCount||c.dataset.cfUcardImageCount||0),slides=qa('.cf-ucard-slide',c).length;return n>=1&&slides===n});
    const relatedThumbs=related.every(c=>{const n=Number(c.dataset.cfUcardImageCount||0),t=qa('.cf-ucard-thumb',c).length;return n<2?t===0:(t>=1&&t<=Math.min(MAX_THUMBS,n))});
    const noThumbsElsewhere=[...recent,...collection,...home].every(c=>qa('.cf-ucard-thumbs',c).length===0);
    const compactDiscountAbsent=[...related,...recent].every(c=>qa('.cf-ucard-discount',c).length===0);
    const singleImageCountAbsent=cards.every(c=>Number(c.dataset.cfUcardMediaCount||c.dataset.cfUcardImageCount||0)>1||qa('.cf-ucard-media-count',c).length===0);
    const recentShape=recent.every(c=>q('.cf-ucard-copy',c)?.dataset.cfUcardCopyOrder==='vendor,title,price,actions,cta');
    const relatedShape=related.every(c=>q('.cf-ucard-copy',c)?.dataset.cfUcardCopyOrder==='vendor,title,price,actions');
    const collectionShape=collection.every(c=>q('.cf-ucard-copy',c)?.dataset.cfUcardCopyOrder==='vendor,type,title,description,source,price,cta,actions');
    const railPass=['collection','related'].every(s=>qa(`[data-cf-ucard-rail="${s}"]`).every(rail=>qa(`[data-cf-ucard-slot="${s}"]`,rail).every(slot=>rectInside(slot,rail,2))));
    const recentRail=q('[data-cf26-recent-rail]'),recentContained=!recentRail||(()=>{const cs=getComputedStyle(recentRail),rr=recentRail.getBoundingClientRect(),localScroll=/auto|scroll/.test(cs.overflowX)&&recentRail.scrollWidth>=recentRail.clientWidth;return localScroll&&recent.every(c=>{const r=c.getBoundingClientRect();return r.width<=recentRail.clientWidth+2&&r.bottom>=rr.top-2&&r.top<=rr.bottom+2})})();
    const activeImagesLoaded=visible.every(c=>{const vm=q('.cf-ucard-slide:first-child video-media',c);if(vm){const v=q('video',vm);return vm.hasAttribute('autoplay')&&(!v||(v.muted&&v.playsInline))}const img=q('.cf-ucard-slide:first-child .cf-ucard-main-image',c);return !!img&&img.complete&&img.naturalWidth>1&&img.naturalHeight>1});
    const homeRailOwnershipAbsent=qa('body.template-index [data-cf-ucard-rail="home"],body.template-index [data-cf-ucard-slot="home"]').length===0;
    const homeShape=home.every(c=>q('.cf-ucard-copy',c)?.dataset.cfUcardCopyOrder==='vendor,type,title,description,source,price,cta,actions');
    const homeExtensionReady=pageScope()!=='home'||(home.length>0&&home.every(c=>c.dataset.cfUcardHomeLayoutOwner==='SHOPIFY_NATIVE_HOME_RAIL'));
    const checks={targetPage:['home','collection','product'].includes(pageScope()),homeNativeRailOwnershipPreserved:homeRailOwnershipAbsent,homeCollectionCardPresentationExtensionReady:homeExtensionReady,ownerExact:window.CANFOTO_E1_F10_R14D_UNIFIED_PRODUCT_CARD_STATE?.version===VERSION,allCardsReady:cards.length>0&&cards.every(c=>c.dataset.cfUcardState==='READY'),allNineProfileContrastPass:rows.every(x=>x.pass),productPoolOrderPreserved:nativeOrderPass&&recentOrderPass,allImageSlidesMatchProductJson:allMedia,relatedThumbnailsMax6:relatedThumbs,noThumbnailRailOnRecentCollectionHome:noThumbsElsewhere,compactSurfaceDiscountBadgeAbsent:compactDiscountAbsent,singleImageHasNoMediaCount:singleImageCountAbsent,relatedCompactHierarchyExact:relatedShape,recentApprovedHierarchyExact:recentShape,collectionSealedHierarchyExact:collectionShape,homeCollectionHierarchyExact:homeShape,allNormalizedRailsContained:railPass,recentRailContained:recentContained,visiblePrimaryImagesLoaded:activeImagesLoaded,documentNoHorizontalOverflow:document.documentElement.scrollWidth<=document.documentElement.clientWidth+1,commerceMutationNone:true,rankingMutationNone:true,scoringMutationNone:true,fpMutationNone:true,setupTruthMutationNone:true};
    const failedChecks=Object.entries(checks).filter(([,v])=>!v).map(([k])=>k),out={ok:failedChecks.length===0,version:'CANFOTO-E1-F10-R14D-SEALED-CARD-PARITY-QA-V1',checks,failedChecks,observed:{page:pageScope(),viewport:innerWidth,profile:original,cardCount:cards.length,relatedCount:related.length,recentCount:recent.length,collectionCount:collection.length,homeCount:home.length,state,rows},physicalRequired:['PDP Alternatifler: masaüstü 4 / mobil 2; main image visible; all images swipe/slide; max 6 thumbnails; no left blank/negative sliver.','PDP Son Görüntülenenler: exact user-approved 4 desktop / 2 mobile rail; dots/count; compact copy/actions.','Collection: sealed REV11 hierarchy, 4 desktop / 2 mobile, no horizontal overflow.','HOME: native F08/Shopify rails/order/limits remain owner; product-card INTERNAL presentation intentionally matches sealed Collection hierarchy. No Home rail/slot marker.','Hover/focus: all 9 profiles preserve their sealed character and readable contrast.']};console.log('=== CANFOTO E1-F10 R14D SEALED CARD PARITY QA V1 ===');console.log(out);console.table(rows);return out;
  };

  async function boot(){
    document.documentElement.dataset.cfStandardSurfaceServerOnly='P0E-R1';
    ensureDomOrderTokens();
    captureOrder(state.initialOrder);
    captureDomOrder(state.initialDomOrder);

    if(pageScope()==='home'){
      /* Keep native Shopify cards in the initial response.
         Enrich each section only as it approaches the viewport. */
      observeHomeOwners();
      captureOrder(state.currentOrder);
      captureDomOrder(state.currentDomOrder);
    }else{
      await adaptAll();
    }

    await renderRecent(true);
    observe();

    document.documentElement.dataset.cfUnifiedProductCard='R14D';
    if(pageScope()==='home'){
      document.documentElement.dataset.cfHomeCardParity='FINAL1-R2H';
      document.documentElement.dataset.cfHomeProductDefer=HOME_DEFER_VERSION;
    }

    window.dispatchEvent(new CustomEvent('canfoto:unified-product-card-ready',{
      detail:{version:VERSION,homeDefer:HOME_DEFER_VERSION}
    }));
  }

  window.debugCanFotoHomeProductDeferP2R1=function(){
    const home=pageScope()==='home';
    const cards=home?nativeTargets():[];
    const owners=home?[...new Set(cards.map(homeOwner).filter(Boolean))]:[];
    const ready=cards.filter(card=>card.dataset.cfUcardState==='READY');
    const pending=cards.filter(card=>card.dataset.cfUcardState==='PENDING');
    const untouched=cards.filter(card=>!card.dataset.cfUcardState);

    const ownerStates=owners.map(owner=>({
      id:owner.id||'',
      state:owner.dataset.cfUcardHomeDeferredState||'',
      observed:owner.dataset.cfUcardHomeDeferredObserved||'0',
      cardCount:cardsForHomeOwner(owner).length
    }));

    const result={
      home,
      version:HOME_DEFER_VERSION,
      totalCards:cards.length,
      readyCards:ready.length,
      pendingCards:pending.length,
      untouchedCards:untouched.length,
      productJsonCacheCount:cache.size,
      ownerCount:owners.length,
      ownerStates,
      duplicateMakeupLoaderPresent:!!document.querySelector(
        'script[data-cf61-home-campaign-loader="1"]'
      ),
      homeDeferOwner:document.documentElement.dataset.cfHomeProductDefer||null
    };

    result.ok=
      !home || (
        result.duplicateMakeupLoaderPresent===false &&
        result.homeDeferOwner===HOME_DEFER_VERSION &&
        ownerStates.every(x=>x.observed==='1')
      );

    console.table({
      home:result.home,
      totalCards:result.totalCards,
      readyCards:result.readyCards,
      pendingCards:result.pendingCards,
      untouchedCards:result.untouchedCards,
      productJsonCacheCount:result.productJsonCacheCount,
      ownerCount:result.ownerCount,
      duplicateMakeupLoaderPresent:result.duplicateMakeupLoaderPresent,
      homeDeferOwner:result.homeDeferOwner,
      ok:result.ok
    });
    return result;
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
